import WorkerEventsPage from './pages/WorkerEventsPage';
// import TeamleaderOverview from './pages/TeamleaderOverview';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
// import TaskEventsPage from './pages/TaskEventsPage';
// import HomePage from './pages/HomePage';
import './App.css';
import AgentRejectedCalls from './pages/AgentRejectedCalls';
import WorkflowsView from './pages/WorkflowViews';
import WorkerDashboard from './components/WorkerDashboard';
import { CsvDataProvider } from './utils/CsvDataContext';
import { EnvironmentProvider } from './utils/EnvironmentContext';
import { useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Telefoonnummers from './pages/TwilioPhoneNumbers';

const App = ({ token, roles, userId }) => {
  const { setToken, setRoles, setUserId } = useAuth();

  useEffect(() => {
    console.log('App props:', { token, roles, userId });
    setToken(token);
    setRoles(roles);
    setUserId(userId);
  }, [token, roles, userId, setToken, setRoles, setUserId]);

  return (
    <EnvironmentProvider>
      <CsvDataProvider>
        <Router>
          <Navbar />
          <main style={{ margin: '1rem 0' }}>
            <Routes>
              {/* <Route
                path="/"
                element={
                  <ProtectedRoute allowedRoles={["admin", "supervisor"]}>
                    <TeamleaderOverview />
                  </ProtectedRoute>
                }
              /> */}
              <Route
                path="/telefoonnummers"
                element={
                  <ProtectedRoute allowedRoles={["admin", "supervisor"]}>
                    <Telefoonnummers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rejected-calls"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
                    <AgentRejectedCalls />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/workflows"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
                    <WorkflowsView />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'supervisor', 'monitoring']}>
                    <WorkerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worker-events"
                element={
                  <ProtectedRoute allowedRoles={['admin', 'supervisor']}>
                    {console.log('Rendering WorkerEventsPage route')}
                    <WorkerEventsPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
        </Router>
      </CsvDataProvider>
    </EnvironmentProvider>
  );
};

export default App;
